<div id="about-main">
  <h1>About</h1>
  <p>Hello, welcome to my website. This contains rather random content for my personal enjoyment. You can access my photo gallery <a routerLink="/pictures">here</a> and my Fantasy Premier League Player Explorer <a routerLink="/players">here</a>.</p>
</div>
